import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { apiClient } from "@/config/api";
import {
  InviteAdminUserBody,
  InviteHomeownerUserBody,
  InviteSuperAdminUserBody,
} from "./types";

export const inviteSuperAdminUser = createAsyncThunk(
  "admin/super-admin",
  async (body: InviteSuperAdminUserBody, { rejectWithValue }) => {
    try {
      const response = await apiClient.post("/admin/super-admin", body);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message ||
            "Invite super-admin user failed"
        );
      }
      return rejectWithValue("Invite super-admin user failed");
    }
  }
);

export const inviteAdminUser = createAsyncThunk(
  "admin/admin",
  async (body: InviteAdminUserBody, { rejectWithValue }) => {
    try {
      const response = await apiClient.post("/admin/admin", body);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message || "Invite admin user failed"
        );
      }
      return rejectWithValue("Invite admin user failed");
    }
  }
);

export const inviteHomeownerUser = createAsyncThunk(
  "admin/homeowner",
  async (body: InviteHomeownerUserBody, { rejectWithValue }) => {
    try {
      const response = await apiClient.post("/admin/homeowner", body);
      return response.data.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(
          error.response?.data?.error?.message || "Invite homeowner user failed"
        );
      }
      return rejectWithValue("Invite homeowner user failed");
    }
  }
);
